import {useEffect, useRef, useState } from "react";
import {UnlockedSongLessonsResponse} from "../../client/models/unlockedSongLessons/UnlockedSongLessonsResponse";
import playgroundApi from "../../services/playgroundApi";
import {
  ISongArrangementCardWithProgress
} from "../songs-router/modules/my-songs-library-store/mySongsLibrary.selector";
import {useScrollPositionPersist} from "../../modules/persist/useScrollPositionPersist";
import { useParams } from "react-router-dom";

export interface IUnlockedSongLessonsPageLogic {
  title: string;
  bonusContentText: string;
  isLoading: boolean;
  songArrangementWithProgress: ISongArrangementCardWithProgress[];
  scrollableContentRef: React.MutableRefObject<HTMLElement>;
  onScrollHandler: () => void;
}

export const useUnlockedSongLessonsPageLogic = (): IUnlockedSongLessonsPageLogic => {
  const routeParams = useParams<{sectionId: string}>();
  const sectionId = parseInt(routeParams.sectionId ?? '');
  const [apiResponse, setApiResponse] = useState<UnlockedSongLessonsResponse|undefined>();
  const [isLoading, setIsLoading] = useState(true);
  const scrollableContentRef = useRef<HTMLElement>(document.createElement('main'));
  const {onScrollHandler} = useScrollPositionPersist<HTMLElement>(`unlockedSongsSection:${sectionId}`, scrollableContentRef);

  useEffect(() => {
    setApiResponse(undefined);
    setIsLoading(true);
    playgroundApi.unlockedSongLessons({sectionId})
      .then((response) => {
        setApiResponse(response);
      }).finally(() => {
        setIsLoading(false);
      });
  }, [sectionId]);

  const {unlockedSongLessons} = apiResponse ?? {unlockedSongLessons: []};
  const songArrangementWithProgress: ISongArrangementCardWithProgress[] = [];
  unlockedSongLessons.forEach((lesson) => {
    const {lessonId, difficultyIdentifier, difficultyName, quantityStars: stars, hasVideo, thumbnailUrl: imageUrl, isFavorited: isFavorite, artistName: subTitle, name: title} = lesson;
    songArrangementWithProgress.push({lessonId, difficultyIdentifier, difficultyName, stars, icon: hasVideo ? 'video' : 'none', imageUrl, isFavorite, subTitle, title,});
  });

  return {
    title: apiResponse?.title ?? "",
    bonusContentText: apiResponse?.bonusContentText ?? "",
    isLoading,
    songArrangementWithProgress,
    scrollableContentRef,
    onScrollHandler,
  };
}
